module.exports = __webpack_public_path__ + "img/Blog-Image.ba894c48.png";